module.exports = __webpack_public_path__ + "img/member-dbz.6639d398.png";